import {
  ButtonStyle,
  ButtonWrapper,
  MikeText,
  CancelledPaymentImage,
  CancelledPaymentImageWrapper,
  CancelledPaymentText,
  CancelledPaymentTextWrapper,
  CancelledPaymentTitle,
  CancelledPaymentTitleWrapper,
  CancelledPaymentWrapper,
} from "./Styles";
import CancelledPaymentPng from "../../../Assets/Vectors/cancelled-payment.png";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useBusiness } from "../../../Common/Hooks/useBusiness";
import { useEffect } from "react";

export const CancelledPayment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { resyncBusiness } = useBusiness();

  const onClick = () => {
    navigate("/choose-plan");
  };

  useEffect(() => {
    setTimeout(() => {
      resyncBusiness();
    }, 1000);
  }, []);

  return (
    <CancelledPaymentWrapper>
      <CancelledPaymentImageWrapper>
        <CancelledPaymentImage src={CancelledPaymentPng} />
      </CancelledPaymentImageWrapper>
      <CancelledPaymentTitleWrapper>
        <CancelledPaymentTitle>{t("common.auxiliar.cancelledPayment.title")}</CancelledPaymentTitle>
      </CancelledPaymentTitleWrapper>
      <CancelledPaymentTextWrapper>
        <CancelledPaymentText>
          <Trans
            i18nKey="common.auxiliar.cancelledPayment.message"
            components={{ 1: <MikeText /> }}
          />
        </CancelledPaymentText>
      </CancelledPaymentTextWrapper>
      <ButtonWrapper>
        <ButtonStyle onClick={onClick}>{t("common.auxiliar.cancelledPayment.goToSubscriptionButton")}</ButtonStyle>
      </ButtonWrapper>
    </CancelledPaymentWrapper>
  );
};
